import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import configureStore from './store';
import fbConfig from "./config";
import firebase from "firebase/app";
import { createFirestoreInstance } from "redux-firestore";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";

const ConvertToReact = (instance) => {

    // Create The Component
    let instanceComponent = React.createElement(instance.component,instance.props);

    // Create the Store
    const store = configureStore();

    // Bind to Firebase
    const rrfProps = {
        firebase,
        config: fbConfig,
        dispatch: store.dispatch,
        createFirestoreInstance,
        userProfile: 'users',
        useFirestoreForProfile: true
    };

    
    // Firebase Provider takes the App
    let instanceFBProvider = React.createElement(ReactReduxFirebaseProvider,{...rrfProps},instanceComponent)

    // Redux Provider take Firebase
    let instanceProvider = React.createElement(Provider,{store},instanceFBProvider);
    

    // Create A Div
    let div = document.createElement('div');
    div.setAttribute('data-component-type',instance.tagName)

    // Replace With Div
    instance.el.parentNode.replaceChild(div, instance.el);

    // Render Component renders Provider
    ReactDOM.render(instanceProvider,div);

}

/**
 * Tag Converter
 * Convert WebComponent Tags into Ract Components
 * @param component ReactComponent
 */

const TagConverter = (component) => {

    // Get Elements By Tag
    var arrayOfElements = [].slice.call(document.getElementsByTagName(component.tagName));

    // Convert Elements to Vue Components
    var instances = arrayOfElements.map((element,index) => {

        // Read Attributes into Props Array
        var props = {};
        [].slice.call(element.attributes).map(attr => props[attr.name] = attr.value);

        return {
            props: props,
            component: component.component,
            tagName: component.tagName,
            el: element,
        };

    });

    // Convert To React Apps
    instances.forEach(ConvertToReact)

}

/**
 * React Launcher
 * Makes Components Accessible Globally
 * @param components Array
 */

const ReactLauncher = (components) => {

    components.forEach(TagConverter);

}

export default ReactLauncher;
